/** Apple-style page hero — shared across admin sections */

export default function AdminPageHero({
  kicker,
  title,
  subtitle,
  children,
  className = '',
}) {
  return (
    <header className={['admin-page-hero', className].filter(Boolean).join(' ')}>
      <div className="admin-page-hero-copy">
        {kicker ? <p className="admin-page-hero-kicker">{kicker}</p> : null}
        <h1 className="admin-page-hero-title">{title}</h1>
        {subtitle ? <p className="admin-page-hero-sub">{subtitle}</p> : null}
      </div>
      {children ? <div className="admin-page-hero-actions">{children}</div> : null}
    </header>
  );
}
